import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/:servicePaymentId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/:servicePaymentId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/:servicePaymentId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/:servicePaymentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].PUT_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/:servicePaymentId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/service_payments/:servicePaymentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}